/* eslint-disable camelcase */
import {
    SET_SURGERY_DETAILS,
    UPDATE_CART_DATA_SHIPPING,
    SET_SHIPPING_DETAILS,
    RESET_SHIPPING_DETAILS,
    HANDLE_SURGERY_NOTES,
    SET_PRICING_NOTES,
    SET_VISUALIZATION_INSPECTION,
    RESET_EQUITY_DETAILS_DATA,
    CHANGE_SHIPPING_SEGMENT_INDEX,
    SET_SHIPPING_DETAILS_EDIT_MODE,
    DISABLE_SURGERY_DATE,
    CURRENT_SURGERY_DATE_SELECTED,
    CHANGE_ACKNOWLEGMENT_VIEW,
    PUT_RECENTLY_USED_PHYSICIANS,
    PUT_RECENTLY_USED_PHYSICIANS_SUCCESS,
    PUT_RECENTLY_USED_PHYSICIANS_FAILURE,
    GET_DERIVED_TERRITORIES,
    SET_DERIVED_TERRITORIES_SUCCESS,
    SET_DERIVED_TERRITORIES_FAILURE,
    GET_HOLIDAY_LIST_SUCCESS,
    INITIAL_EQUITY_DATA,
} from '../actions';
import {
    SET_CART_DATA,
    SET_CART_DATA_PRICE_OVERRIDE,
    UPDATE_CART_DATA,
    UPDATE_CART_PRODUCTS_QUANTITY,
    CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT,
    STORE_EQUITY_DETAILS,
    RESET_CART_DATA,
    UPDATE_CART_DATA_PRICEOVERRIDE,
    SET_ORDER_FROM_REPORT_USAGE,
    SET_EQUITY_CU_IN_PROGRESS,
    SET_EQUITY_ORDER_SUBMITTED,
    RESET_DERIVED_TERRITORIES,
    SET_PRODUCT_TEMPLATE_UID,
} from '../actions/actionTypes';
import { TISSUE_AND_NON_TISSUE_SALES_ORG } from 'src/constants/productConstants';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { generate_UUID } from 'src/utils/util';

const updateCartProducts = (
    products,
    { operation, productKey, isSet, childProductKey }
) => {
    const clonedProducts = [...products];
    const index = clonedProducts.findIndex(
        (item) => item.productKey === productKey
    );
    if (!childProductKey) {
        if (operation === 'increment' && isSet) {
            clonedProducts.push({
                ...clonedProducts[index],
                productKey: generate_UUID(),
            });
        } else if (operation === 'decrement' && isSet) {
            clonedProducts.splice(index, 1);
        } else if (operation === 'increment' && !isSet) {
            clonedProducts[index].quantity =
                parseInt(clonedProducts[index].quantity) + 1;
        } else {
            clonedProducts[index].quantity = clonedProducts[index].quantity - 1;
        }
    } else {
        if (clonedProducts[index].children && clonedProducts[index].children.length > 0) {
            const childIndex = clonedProducts[index].children.findIndex(
                (item) => item.productKey === childProductKey
            );
            if (childIndex >= 0) {
                if (operation === 'increment') {
                    clonedProducts[index].children[childIndex].quantity =
                        parseInt(clonedProducts[index].children[childIndex].quantity) +
                        1;
                } else if (operation === 'decrement') {
                    clonedProducts[index].children[childIndex].quantity =
                        clonedProducts[index].children[childIndex].quantity - 1;
                }
            }
        }
    }

    return clonedProducts;
};

const updateCartProductsQuantity = (
    products,
    { quantity, productKey, childProductKey }
) => {
    const clonedProducts = [...products];
    const index = clonedProducts.findIndex(
        (item) => item.productKey === productKey
    );
    if (!childProductKey) {
        clonedProducts[index].quantity = quantity;
    } else {
        if (clonedProducts[index].children && clonedProducts[index].children.length > 0) {
            const childIndex = clonedProducts[index].children.findIndex(
                (item) => item.productKey === childProductKey
            );
            if (childIndex >= 0) {
                clonedProducts[index].children[childIndex].quantity = quantity;
            }
        }
    }

    return clonedProducts;
};

const updateCartProductsShipping = (products, fieldsToBeAdded, productKeys) => {
    const clonedProducts = [...products];
    for (let i in productKeys) {
        for (let j in clonedProducts) {
            if (productKeys[i] === clonedProducts[j].productKey) {
                clonedProducts[j] = {
                    ...clonedProducts[j],
                    ...fieldsToBeAdded,
                };
                break;
            }
        }
    }

    return clonedProducts;
};

// const objParamsFunc = (stateValues, payload, objParams) => {
//     var value4 = { ...stateValues };

//     var objElement = (value4[Object.keys(payload)[0]][payload.objParams] =
//         payload[Object.keys(payload)[0]]);
//     return objElement;
// };

const handlePayloadFunc = (stateValues, payload, objParams) => {
    var value4 = { ...stateValues };

    // objParams
    //     ? (value4[Object.keys(payload)[0]][payload.objParams] =
    //           payload[Object.keys(payload)[0]])
    //     : payload;

    var objElement = objParams
        ? (value4[Object.keys(payload)[0]][payload.objParams] =
              payload[Object.keys(payload)[0]])
        : payload;
    return objElement;
};

const initialState = {
    formType: 'AddEquity/ModifyEquity',
    equityDetails: {
        districtId: '',
        territoryId: '',
        procedureCode: '',
        accountId: '',
        surgeryDateTime: '',
        surgeryDuration: '',
        physicianId: '',
        caseCoverageId: '',
        hrefId: '',
        patientFirstName: '',
        patientLastName: '',
        patientSalutation: '',
        patientSex: '',
        patientDOB: '',
        patientContactName: '',
        patientContactNumber: '',
        inventoryShipping: false,
        physicianDropDown: '',
        template: '',
        surgeryTimeWithoutEDT: '',
    },
    notes: [],
    pricingNotes: '',
    cartData: {
        products: [],
        getPricesForItems: [],
        templateUId: '',
        overriddenReason: '',
        pricingNotes: '',
        overrideDiscount: '',
    },
    cartDataForPriceOverride: {
        products: [],
        templateUId: '',
    },
    shippingDetails: {
        [TISSUE_AND_NON_TISSUE_SALES_ORG.tissue]: {
            attention: '',
            payment: {
                poAttachment: '',
                poNumber: '',
            },
            salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.tissue,
            shippingAddressId: '',
            shippingMethodId: '',
            userAcknowledgement: false,
        },
        [TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue]: {
            attention: '',
            payment: {
                poAttachment: '',
                poNumber: '',
            },
            salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue,
            shippingAddressId: '',
            shippingMethodId: '',
            userAcknowledgement: false,
        },
    },
    derivedTerritoryDetails: {},
    derivedTerritoryLoading: false,
    derivedTerritoryStatusCode: 0,
    derivedTerritoryStatusMessage: '',
    visualInspectionAcknowledgement: false,
    surgeryLoading: false,
    surgeryError: false,
    selectedShippingSegment: 0, // Selected segment of shipping section
    tissueAcknowlegmentCheckBox: false, //selected checkbox for shipping section
    nonTissueAcknowlegmentCheckBox: false, //selected checkbox for shipping section
    disableSurgeryDate: false, // disable surgery date of details section for past date
    currentSurgeryDateSelected: false,
    showAcknowlegment: {
        tissue: false,
        nontissue: false,
    },
    equityCUInProgress: true,
    recenlyUsedPhysicians: {},
    isHoliday: '',
    pricedItems: null,
    isPricingDone: null,
    myCaseRefId: null,
    myCaseResourceType: null,
    fromOrdersList: false,
    isOrderFromReportUsage: false,
    isFromUsage: false,
    isFromOrderHistory: false,
    isCopyFromSummary: false,
    reportUsageMyCaseRef: null,
    productTemplateUID: [],
};

const initialStateDetails = {
    formType: 'AddEquity/ModifyEquity',
    equityDetails: {
        districtId: '',
        territoryId: '',
        procedureCode: '',
        accountId: '',
        surgeryDateTime: '',
        surgeryDuration: '',
        physicianId: '',
        caseCoverageId: '',
        hrefId: '',
        patientFirstName: '',
        patientLastName: '',
        patientSalutation: '',
        patientSex: '',
        patientDOB: '',
        patientContactName: '',
        patientContactNumber: '',
        inventoryShipping: false,
        physicianDropDown: '',
        template: '',
        surgeryTimeWithoutEDT: '',
    },
    notes: [],
    pricingNotes: '',
    cartData: {
        products: [],
        getPricesForItems: [],
        templateUId: '',
        overriddenReason: '',
        pricingNotes: '',
        overrideDiscount: '',
    },
    cartDataForPriceOverride: {
        products: [],
        templateUId: '',
    },
    derivedTerritoryDetails: {},
    derivedTerritoryLoading: false,
    derivedTerritoryStatusCode: 0,
    derivedTerritoryStatusMessage: '',
    visualInspectionAcknowledgement: false,
    surgeryLoading: false,
    surgeryError: false,
    selectedShippingSegment: 0, // Selected segment of shipping section
    tissueAcknowlegmentCheckBox: false, //selected checkbox for shipping section
    nonTissueAcknowlegmentCheckBox: false, //selected checkbox for shipping section
    disableSurgeryDate: false, // disable surgery date of details section for past date
    currentSurgeryDateSelected: false,
    showAcknowlegment: {
        tissue: false,
        nontissue: false,
    },
    equityCUInProgress: true,
    recenlyUsedPhysicians: {},
    isHoliday: '',
    pricedItems: null,
    isPricingDone: null,
    myCaseRefId: null,
    myCaseResourceType: null,
    fromOrdersList: false,
    isOrderFromReportUsage: false,
    isEquityOrderSubmitted: false,
    isFromUsage: false,
    isFromOrderHistory: false,
    isCopyFromSummary: false,
    reportUsageMyCaseRef: null,
    productTemplateUID: [],
};

const initialShippingDetails = {
    [TISSUE_AND_NON_TISSUE_SALES_ORG.tissue]: {
        attention: '',
        payment: {
            poAttachment: '',
            poNumber: '',
        },
        salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.tissue,
        shippingAddressId: '',
        shippingMethodId: '',
        userAcknowledgement: false,
    },
    [TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue]: {
        attention: '',
        payment: {
            poAttachment: '',
            poNumber: '',
        },
        salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue,
        shippingAddressId: '',
        shippingMethodId: '',
        userAcknowledgement: false,
    },
};

const EquityReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SURGERY_DETAILS:
            return {
                ...state,
                equityDetails: {
                    ...state.equityDetails,
                    patientContactName:
                        state.equityDetails.patientContactName.trim(),
                    ...action.payload,
                },
            };
        case SET_CART_DATA:
            const productsWithBundleChildren = action.payload.products
                ? action.payload.products.map((product) => ({
                    ...product,
                    children: product.children || product.bundleItems || (product.materialType === 'ZKMT' ? [] : product.children),
                  }))
                : state.cartData.products;
            return {
                ...state,
                cartData: {
                    products: productsWithBundleChildren,
                    getPricesForItems: productsWithBundleChildren,
                    templateUId: action.payload.templateUId
                        ? { ...action.payload.templateUId }
                        : action.payload.templateUId == ''
                        ? ''
                        : state.cartData.templateUId,
                    overriddenReason: action.payload.overriddenReason
                        ? action.payload.overriddenReason
                        : action.payload.overriddenReason === ''
                        ? ''
                        : state.cartData.overriddenReason,
                    pricingNotes: action.payload.pricingNotes
                        ? action.payload.pricingNotes
                        : action.payload.pricingNotes === ''
                        ? ''
                        : state.cartData.pricingNotes,
                    overrideDiscount: action.payload.overrideDiscount
                        ? action.payload.overrideDiscount
                        : action.payload.overrideDiscount === ''
                        ? ''
                        : state.cartData.overrideDiscount,
                },
                isFromUsage: action.payload.isFromUsage
                    ? action.payload.isFromUsage
                    : state.isFromUsage,
                isFromOrderHistory: action.payload.isFromOrderHistory
                    ? action.payload.isFromOrderHistory
                    : state.isFromOrderHistory,
                isCopyFromSummary: action.payload.isCopyFromSummary
                    ? action.payload.isCopyFromSummary
                    : state.isCopyFromSummary,
                reportUsageMyCaseRef: action.payload.reportUsageMyCaseRef
                    ? action.payload.reportUsageMyCaseRef
                    : state.reportUsageMyCaseRef,
            };
        case SET_CART_DATA_PRICE_OVERRIDE: //nami
            return {
                ...state,
                cartDataForPriceOverride: {
                    products: action.payload.products,

                    overriddenReason: action.payload.overriddenReason
                        ? action.payload.overriddenReason
                        : action.payload.overriddenReason === ''
                        ? ''
                        : state.cartDataForPriceOverride.overriddenReason,
                    pricingNotes: action.payload.pricingNotes
                        ? action.payload.pricingNotes
                        : action.payload.pricingNotes === ''
                        ? ''
                        : state.cartDataForPriceOverride.pricingNotes,
                    overrideDiscount: action.payload.overrideDiscount
                        ? action.payload.overrideDiscount
                        : action.payload.overrideDiscount === ''
                        ? ''
                        : state.cartDataForPriceOverride.overrideDiscount,
                },
            };
        case UPDATE_CART_DATA:
            return {
                ...state,
                cartData: {
                    products: updateCartProducts(
                        state.cartData.products,
                        action.payload
                    ),
                    getPricesForItems: action.payload.products
                        ? [...action.payload.products]
                        : state.cartData.products,
                    templateUId: action.payload.templateUId
                        ? { ...action.payload.templateUId }
                        : action.payload.templateUId == ''
                        ? ''
                        : state.cartData.templateUId,
                    overriddenReason: action.payload.overriddenReason
                        ? action.payload.overriddenReason
                        : action.payload.overriddenReason === ''
                        ? ''
                        : state.cartData.overriddenReason,
                    pricingNotes: action.payload.pricingNotes
                        ? action.payload.pricingNotes
                        : action.payload.pricingNotes === ''
                        ? ''
                        : state.cartData.pricingNotes,
                    overrideDiscount: action.payload.overrideDiscount
                        ? action.payload.overrideDiscount
                        : action.payload.overrideDiscount === ''
                        ? ''
                        : state.cartData.overrideDiscount,

                    // getPricedForItems: state.cartData.products,
                },
            };
        case UPDATE_CART_PRODUCTS_QUANTITY:
            return {
                ...state,
                cartData: {
                    products: updateCartProductsQuantity(
                        state.cartData.products,
                        action.payload
                    ),
                    // getPricedForItems: updateCartProductsQuantity(
                    //     state.cartData.products,
                    //     action.payload
                    // ),
                },
            };
        case UPDATE_CART_DATA_PRICEOVERRIDE:
            return {
                ...state,
                cartDataForPriceOverride: {
                    products: action.payload.products,
                    overriddenReason: action.payload.overriddenReason
                        ? action.payload.overriddenReason
                        : action.payload.overriddenReason === ''
                        ? ''
                        : state.cartDataForPriceOverride.overriddenReason,
                    pricingNotes: action.payload.pricingNotes
                        ? action.payload.pricingNotes
                        : action.payload.pricingNotes === ''
                        ? ''
                        : state.cartDataForPriceOverride.pricingNotes,
                    overrideDiscount: action.payload.overrideDiscount
                        ? action.payload.overrideDiscount
                        : action.payload.overrideDiscount === ''
                        ? ''
                        : state.cartDataForPriceOverride.overrideDiscount,
                },
            };
        case UPDATE_CART_DATA_SHIPPING:
            return {
                ...state,
                cartData: {
                    products: updateCartProductsShipping(
                        state.cartData.products,
                        action.payload.newFields,
                        action.payload.productKeys
                    ),
                },
            };
        case SET_PRICING_NOTES:
            return {
                ...state,
                cartData: {
                    products: state.cartData.products,
                    pricingNotes: action.payload,
                },
            };
        case SET_SHIPPING_DETAILS:
            return {
                ...state,
                shippingDetails: {
                    ...state.shippingDetails,
                    [action.payload.salesOrg === 'S030' || 
                        action.payload.salesOrg === 'S002'
                        ? action.payload.salesOrg
                        : 'S002']:{ 
                        ...state.shippingDetails[action.payload.salesOrg],
                        ...handlePayloadFunc(
                            state.shippingDetails[action.payload.salesOrg],
                            action.payload,
                            action.payload.objParams
                        ),
                    },
                },
            };
        case RESET_SHIPPING_DETAILS:
            return {
                ...state,
                shippingDetails: initialShippingDetails,
            };
        case SET_SHIPPING_DETAILS_EDIT_MODE:
            return {
                ...state,
                shippingDetails: action.payload,
            };
        case HANDLE_SURGERY_NOTES:
            return {
                ...state,
                notes: action.payload,
            };
        case SET_VISUALIZATION_INSPECTION:
            return {
                ...state,
                visualInspectionAcknowledgement: action.payload,
            };
        case RESET_EQUITY_DETAILS_DATA:
            return {
                ...state,
                ...initialState,
            };
        case CHANGE_SHIPPING_SEGMENT_INDEX:
            return {
                ...state,
                selectedShippingSegment: action.payload,
            };
        case CHANGE_ACKNOWLEGMENT_VIEW:
            return {
                ...state,
                showAcknowlegment: {
                    ...state.showAcknowlegment,
                    [action.payload.name]: action.payload.value,
                },
            };
        case CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT:
            return {
                ...state,
                [action.payload.name]: action.payload.value,
            };
        case DISABLE_SURGERY_DATE:
            return {
                ...state,
                disableSurgeryDate: action.payload,
            };
        case CURRENT_SURGERY_DATE_SELECTED:
            return {
                ...state,
                currentSurgeryDateSelected: action.payload,
            };
        case SET_EQUITY_CU_IN_PROGRESS:
            return {
                ...state,
                equityCUInProgress: action.data,
            };
        case PUT_RECENTLY_USED_PHYSICIANS:
            return {
                ...state,
            };
        case PUT_RECENTLY_USED_PHYSICIANS_SUCCESS:
            return {
                ...state,
                recenlyUsedPhysicians: action.data,
            };
        case PUT_RECENTLY_USED_PHYSICIANS_FAILURE:
            return {
                ...state,
                recenlyUsedPhysicians: action.templateError,
            };
        case GET_DERIVED_TERRITORIES:
            return {
                ...state,
                derivedTerritoryDetails: {},
                derivedTerritoryLoading: true,
            };

        case SET_DERIVED_TERRITORIES_SUCCESS:
            return {
                ...state,
                derivedTerritoryDetails: {
                    ...state.derivedTerritoryDetails,
                    interTerritoryId: action.interTerritoryId,
                    nonInterTerritoryId: action.nonInterTerritoryId,
                    derivedResponse: action.derivedResponse,
                },
                derivedTerritoryStatusCode: action.statusCode,
                derivedTerritoryStatusMessage: action.statusMessage,
                derivedTerritoryLoading: false,
            };

        case SET_DERIVED_TERRITORIES_FAILURE:
            return {
                ...state,
                derivedTerritoryDetails: {},
                derivedTerritoryStatusCode: action.statusCode,
                derivedTerritoryStatusMessage: action.statusMessage,
                derivedTerritoryLoading: false,
            };
        case GET_HOLIDAY_LIST_SUCCESS:
            return {
                ...state,
                isHoliday: action.payload,
            };
        case STORE_EQUITY_DETAILS:
            return {
                ...state,
                equityData: action.payload,
                myCaseRefId:
                    action.payload && action.payload.myCaseRef
                        ? action.payload.myCaseRef
                        : state.myCaseRefId,
                myCaseResourceType:
                    action.payload && action.payload.resourceType
                        ? action.payload.resourceType
                        : state.myCaseResourceType,
                fromOrdersList:
                    action.payload && action.payload.fromOrdersList
                        ? action.payload.fromOrdersList
                        : state.fromOrdersList,
            };
        case RESET_CART_DATA:
            // state.shippingDetails = {};
            // console.log('state===', state);

            return {
                ...state,
                shippingDetails: {
                    [TISSUE_AND_NON_TISSUE_SALES_ORG.tissue]: {
                        attention: '',
                        payment: {
                            poAttachment: '',
                            poNumber: '',
                        },
                        salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.tissue,
                        shippingAddressId: '',
                        shippingMethodId: '',
                        userAcknowledgement: false,
                    },
                    [TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue]: {
                        attention: '',
                        payment: {
                            poAttachment: '',
                            poNumber: '',
                        },
                        salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue,
                        shippingAddressId: '',
                        shippingMethodId: '',
                        userAcknowledgement: false,
                    },
                },
                ...initialStateDetails,
            };
        case INITIAL_EQUITY_DATA:
            return {
                ...state,
                ...initialState,
                // Preserve the copy-from-order-history flag. This reset fires
                // when advancing past the account step; without preserving it,
                // the order would revert to an update (PUT) of the source order
                // instead of creating a brand new order (POST).
                isFromOrderHistory: state.isFromOrderHistory,
                // Same reasoning for the copy-from-summary flag (copy from the
                // normal order listing page) so it also stays a new order.
                isCopyFromSummary: state.isCopyFromSummary,
            };
        case SET_ORDER_FROM_REPORT_USAGE:
            return {
                ...state,
                isOrderFromReportUsage: action.payload,
            };
        case SET_EQUITY_ORDER_SUBMITTED:
            return {
                ...state,
                isEquityOrderSubmitted: action.data,
            };
        case RESET_DERIVED_TERRITORIES:
            return {
                ...state,
                derivedTerritoryDetails: {},
            };
        case SET_PRODUCT_TEMPLATE_UID: {
            let temp = [];
            if (action.payload.length) {
                temp = [...state.productTemplateUID];
                temp.push(action.payload);
            }
            return {
                ...state,
                productTemplateUID: temp,
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'equityKey',
        storage: storage,
        //transforms: [SetTransform],
    },
    EquityReducer
);
